import { useMemo } from 'react';
import { useFindDepartment } from './Departments';

export const useIsDpElectronico = (productId?: string) => {
	const { data, ...rest } = useFindDepartment({
		catentries: productId,
	});

	const isDpElectronico = useMemo(() => {
		if (!data) {
			return false;
		}

		const product = Object.entries(data?.departments).find(
			([_, value]) => value === 'electronicos'
		);

		return !!product;
	}, [data]);

	return {
		isDpElectronico,
		data,
		...rest,
	};
};
